import { IconNames } from '@blueprintjs/icons';
import { DialogWithForm } from '@strata/react-dialog';
import { PhoneInputFormik } from '@strata/react-inputs';
import { Icon } from '@strata/react-status-icons';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';

import { useAppDispatch, useAppSelector } from 'store';
import { FormSections } from 'store/intakeForm/intakeFormSchema';
import { updateCapturedData } from 'store/intakeForm/intakeFormSlice';

export const EditPatientPhoneNumberDialog = () => {
    const dispatch = useAppDispatch();
    const capturedData = useAppSelector((state) => state.intakeForm.capturedData);
    const [isOpen, setIsOpen] = useState(false);
    const validationSchema = Yup.object({
        memberPhoneNumber: PhoneInputFormik.validator().required(
            validationStrings.requiredField.errorMessage,
        ),
    });
    return (
        <>
            <Icon
                icon={IconNames.EDIT}
                intent={Icon.Intent.SUCCESS}
                size={14}
                onClick={() => setIsOpen(true)}
                title="Edit Patient Phone Number"
            />
            <Formik
                initialValues={{
                    memberPhoneNumber: capturedData[FormSections.PATIENT].memberPhoneNumber,
                }}
                validationSchema={validationSchema}
                enableReinitialize
                onSubmit={(values) => {
                    dispatch(
                        updateCapturedData({
                            [FormSections.PATIENT]: {
                                ...capturedData[FormSections.PATIENT],
                                memberPhoneNumber: values.memberPhoneNumber,
                            },
                        }),
                    );
                    setIsOpen(false);
                }}
            >
                {(formik) => (
                    <DialogWithForm
                        isOpen={isOpen}
                        dialogTitle="Edit Patient Phone Number"
                        primaryButtonLabel="Update Patient Phone Number"
                        secondaryButtonLabel="Return To Intake Form"
                        isPrimaryButtonDisabled={!(formik.isValid && formik.dirty)}
                        onSecondaryButtonClick={() => {
                            setIsOpen(false);
                            formik.handleReset();
                        }}
                        dialogContent={
                            <PhoneInputFormik
                                id="memberPhoneNumber"
                                label="Patient Phone Number"
                                required
                            />
                        }
                    />
                )}
            </Formik>
        </>
    );
};
